import { render, staticRenderFns } from "./ForumPage.vue?vue&type=template&id=29bd0a66&"
import script from "./ForumPage.vue?vue&type=script&lang=js&"
export * from "./ForumPage.vue?vue&type=script&lang=js&"
import style0 from "../styles/forum.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports